var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grid is-flex-grow-1" },
    [
      _c("DashboardQuoteStatus", {
        staticClass: "cell",
        attrs: {
          quotes: _vm.quotes,
          "is-loading": _vm.isLoading,
          "is-uninvoiced-jobs-and-chart-disabled":
            _vm.isUninvoicedJobsAndChartDisabled,
        },
        on: { handleQuoteRedirect: _vm.handleQuoteRedirect },
      }),
      _c("DashboardJobStatus", {
        staticClass: "cell",
        attrs: {
          quotes: _vm.quotes,
          "is-loading": _vm.isLoading,
          "is-uninvoiced-jobs-and-chart-disabled":
            _vm.isUninvoicedJobsAndChartDisabled,
        },
        on: { handleQuoteRedirect: _vm.handleQuoteRedirect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }